<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="ki" size="xl"
                                title="Klanten importeren uit ander fiscaal pakket">

    <snelstart-ui-dialog-header-content>
        Gebruik je nu Exact Online Fiscaal of Nextens voor je fiscale aangiften en wil je overstappen naar SnelStart
        Fiscaal? <br/>
        Upload dan in een paar stappen de klantenlijst die je kan exporteren bij Exact Online Fiscaal of Nextens. Bewaar
        deze bestanden ook op je computer. <br/>
        Lees in dit <a href="https://kennisplein.snelstart.nl/snelstartpolaris/klanten-importeren-uit-fiscale-pakketten"
                       target="_blank">Kennisplein-artikel</a> meer over de import en welke gegevens worden
        geïmporteerd.

    </snelstart-ui-dialog-header-content>

    <snelstart-ui-dialog-body>
        <div class="pt-2">
            <form [formGroup]="uploadFg">
                <snelstart-ui-stepper [items]="items"></snelstart-ui-stepper>
                <div class="pt-3">
                    @if (items[0].state === 'active') {
                        <snelstart-ui-select-form-control (change)="this.handleStepClick()"
                                                          [options]="this.optionsPakketten"
                                                          class="custom-input-250"
                                                          formControlName="name"
                                                          id="huidigPakket"
                                                          label='Selecteer je huidige fiscale pakket'
                        >
                        </snelstart-ui-select-form-control>
                        @if (hasError) {
                            <snelstart-ui-alert type="info">
                                {{ error }}
                                <br/>
                            </snelstart-ui-alert>
                        }
                    }
                    @if (items[1].state === 'active') {
                        @if (uploadFg.get('name')?.value === 'Exact Fiscaal Online') {
                            <snelstart-ui-alert type="info">
                                In Exact Online Fiscaal kun je via "Cliënten > Exporteren' het klantenbestand
                                downloaden. Je krijgt dan een zgn. zipbestand met daarin 2 afzonderlijke
                                klantenbestanden.
                                Een (csv) bestand heeft de naam "Ondernemingen' en het andere (cvs) bestand is genaamd
                                'Personen'.
                                <br/><br/>
                                Download in Exact Fiscaal Online nu eerst deze twee bestanden. Upload dan hieronder
                                eerst het bestand met de naam "<b>Ondernemingen.csv</b>".
                            </snelstart-ui-alert>
                            <div class="file-upload pt-2">
                                <input #fileUpload (change)="onFileSelected($event); this.handleStepClick()"
                                       accept=".xls,.xlsx,.csv" class="file-input" type="file">
                                <snelstart-ui-button (click)="fileUpload.click()"
                                                     class="upload-btn"
                                                     icon="cloud-arrow-up"
                                                     type="secondary"
                                >
                                    Selecteer Ondernemingen.csv
                                </snelstart-ui-button>
                            </div>
                        }
                        @if (uploadFg.get('name')?.value === 'Nextens') {
                            <snelstart-ui-alert type="info">
                                Je maakt nu gebruik van {{ uploadFg.get('name')?.value }} voor je fiscale aangiften.
                                Je kunt in {{ uploadFg.get('name')?.value }} de klantenlijst als Excel-bestand (.xlsx)
                                downloaden.
                                <br/>
                                Download eerst dit klantenbestand. Upload daarna hieronder het bestand.
                            </snelstart-ui-alert>
                            <div class="file-upload pt-2">
                                <input #fileUpload (change)="onFileSelected($event); this.handleStepClick()"
                                       accept=".xls,.xlsx" class="file-input" type="file">
                                <snelstart-ui-button (click)="fileUpload.click()"
                                                     class="upload-btn"
                                                     icon="cloud-arrow-up"
                                                     type="secondary"
                                >
                                    Selecteer Excel-bestand
                                </snelstart-ui-button>
                            </div>
                        }
                    }
                    @if (items[2].state === 'active') {
                        @if (this.loading) {
                            <snelstart-ui-spinner size="extraLarge">
                            </snelstart-ui-spinner>
                            <snelstart-ui-alert style="padding: 1.5em" type="info">
                                Het bestand '{{ this.fileName }}' wordt nu ingelezen. Dit kan even duren...
                            </snelstart-ui-alert>
                        } @else {
                            <snelstart-ui-alert type="success">
                                {{ this.message }}
                            </snelstart-ui-alert>
                        }
                    }
                    @if (items[3].state === 'active') {
                        <input #fileUpload (change)="onFileSelected($event); this.handleStepClick()"
                               accept=".xls,.xlsx,.csv"
                               class="file-input" type="file">
                        <snelstart-ui-alert type="info">
                            Je hebt het csv-bestand 'Ondernemingen' geüpload. Upload nu hieronder het csv-bestand met
                            'Personen'.
                            <br/><br>
                            Let op! Indien er bij een persoon eenzelfde fiscaal nummer (bsn) vermeld is als bij een
                            onderneming (eenmanszaak), dan wordt er <b>geen nieuwe klant</b> aangemaakt. De onderneming
                            staat dan vermeld als klant. Bij de klantinstellingen van de onderneming kunnen zaken als
                            belastingplicht ingevuld worden, waarna de modules als inkomstenbelasting beschikbaar is.
                        </snelstart-ui-alert>
                        <div class="file-upload pt-2">
                            <input #fileUpload (change)="onFileSelected($event); this.handleStepClick()"
                                   accept=".xls,.xlsx"
                                   class="file-input" type="file">
                            <snelstart-ui-button (click)="fileUpload.click()"
                                                 class="upload-btn"
                                                 icon="cloud-arrow-up"
                                                 style="min-width: 300px !important;"
                                                 type="secondary"
                            >
                                Selecteer Personen.csv
                            </snelstart-ui-button>
                        </div>
                    }
                    @if (items[4].state === 'active') {
                        @if (this.loading) {
                            <snelstart-ui-spinner size="extraLarge">
                            </snelstart-ui-spinner>
                            <snelstart-ui-alert style="padding: 1.5em" type="info">
                                Het bestand '{{ this.fileName }}' wordt nu ingelezen. Dit kan even duren...
                            </snelstart-ui-alert>
                        } @else {
                            <snelstart-ui-alert type="success">
                                {{ this.message }}
                            </snelstart-ui-alert>
                        }
                    }
                    @if (activeItem?.label === 'Afsluiten') {
                        <snelstart-ui-alert type="success">
                            Het importeren van de klanten is nu voltooid. Dit scherm kan afgesloten worden. Als de
                            nieuwe klanten niet direct zichtbaar zijn, ververs dan je browser.
                            <br/><br/>
                            Het is altijd mogelijk de klantenlijst opnieuw in te lezen. De klanten worden dan ge-update
                            met de gegevens uit het laatst geïmporteerde bestand.
                        </snelstart-ui-alert>
                    }
                </div>
            </form>
        </div>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
        <!-- Cancel -->
        <snelstart-ui-button
                (click)="resetDialog()"
                btn-x
                class="me-1"
                id="cancel"
                type="secondary"
        >
            Cancel
        </snelstart-ui-button>

        <!-- Afsluiten -->
        <snelstart-ui-button
                (click)="resetDialog()"
                [disabled]="activeItem?.label !== 'Afsluiten'"
                id="save"
                type="primary"
        >
            Afsluiten
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>




